import axios from "axios";
import Config from "../config"
import { useLoginStore } from "../stores/login.js";
// const store = useLoginStore();

export default class AnalyticsService {
    constructor() {
        this.loginStore = null;
    }

    store() {
        if (!this.loginStore) { this.loginStore = useLoginStore(); };
        return this.loginStore;
    }

    // getKPIConfig(accesstoken) {
    //     console.log("getKPIConfig access token --> ", accesstoken);
    //     if (Config.mock) {
    //         return axios
    //             .get(
    //                 "stubs/analytics_dynamic_kpi.json?t=" + new Date().getTime(),
    //             )
    //             .then(res => res.data);
    //     }
    //     //     const options = {
    //     //       headers: { ...Config.headers(accesstoken), ...{} }
    //     //     };
    //     //     return axios
    //     //       .get(
    //     //         Config.proxy + Config.url("appliance") + "/appliances",
    //     //         options
    //     //       )
    //     //       .then(res => res.data.body);
    //     return null;
    // }

    getChartByKPISingleAppliance(accesstoken, params, deviceID) {
        const options = {
            headers: {
                ...Config.headers(accesstoken), ...{}
            },
        }

        params.filters.push({
            "field": "deviceCode",
            "operator": "equals",
            "value": deviceID,
        });

        let bodyTosend = {
            start: params.startDate,
            end: params.endDate,
            filters: params.filters
        };

        return axios
            .post(
                Config.url("chart") + "/" + params.kpi,
                bodyTosend,
                options
            )
            .then(res => res.data);
    }
    getChartByKPISingleApplianceOnTenant(accesstoken, params, deviceID, tenant) {
        const options = {
            headers: {
                ...Config.headers(accesstoken), ...{}
            },
        }

        params.filters.push({
            "field": "deviceCode",
            "operator": "equals",
            "value": deviceID,
        });

        let bodyTosend = {
            start: params.startDate,
            end: params.endDate,
            filters: params.filters
        };

        return axios
            .post(
                Config.urlOnTenant("chart", tenant) + "/" + params.kpi,
                bodyTosend,
                options
            )
            .then(res => res.data);
    }

    getChartByKPI(accesstoken, params) {
        const options = {
            headers: {
                ...Config.headers(accesstoken), ...{}
            },
            cancelToken: this.store().getSource.token

        }
        // if (params.kpi === "kpi_wc_37" || params.kpi === "kpi_wc_38") {
        //     params.filters.push({
        //         "field": "deviceCode",
        //         "operator": "equals",
        //         "value": "f2256d90-04b8-4176-a82d-85016497d7c6"
        //     });
        //     if (params.kpi === "kpi_wc_37"){
        //         params.kpi = "kpi_wc_39";
        //     } else {
        //         params.kpi = "kpi_wc_27"
        //     }
        // }

        let bodyTosend = {
            start: params.startDate,
            end: params.endDate,
            filters: params.filters
        };

        return axios
            .post(
                Config.url("chart") + "/" + params.kpi,
                bodyTosend,
                options,
            )
            .then(res => res.data);
    }

    getChartByKPIOnTenant(accesstoken, params, tenant) {
        const options = {
            headers: {
                ...Config.headers(accesstoken), ...{}
            },
            cancelToken: this.store().getSource.token

        }
        // if (params.kpi === "kpi_wc_37" || params.kpi === "kpi_wc_38") {
        //     params.filters.push({
        //         "field": "deviceCode",
        //         "operator": "equals",
        //         "value": "f2256d90-04b8-4176-a82d-85016497d7c6"
        //     });
        //     if (params.kpi === "kpi_wc_37"){
        //         params.kpi = "kpi_wc_39";
        //     } else {
        //         params.kpi = "kpi_wc_27"
        //     }
        // }

        let bodyTosend = {
            start: params.startDate,
            end: params.endDate,
            filters: params.filters
        };

        return axios
            .post(
                Config.urlOnTenant("chart", tenant) + "/" + params.kpi,
                bodyTosend,
                options,
            )
            .then(res => res.data);
    }

    getSdaKpi09(params) {
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{}
            },
        }

        let bodyTosend = {
            start: params.startDate,
            end: params.endDate,
            filters: params.filters
        };

        return axios
            .post(
                Config.url("pageStatistics"),
                bodyTosend,
                options,
            )
            .then(res => res.data);
    }

    async saveSnapshot(snapshot) {
        const options = {
            headers: {
                ...Config.headers(this.store().getAccessToken), ...{}
            }
        }

        let bodyTosend = {
            "data": snapshot
        };

        return axios
            .post(
                Config.url("saveSnapshot"),
                bodyTosend,
                options,
            )
            .then(res => res.data);
    }
}